import { motion } from "framer-motion";
import {
  BadgeCheck, Zap, ShieldAlert, Wrench, Users, Sparkles,
  LifeBuoy, Truck, Building2, Cpu, Award, HeadphonesIcon,
} from "lucide-react";

const ITEMS = [
  { icon: BadgeCheck, title: "Sin costo de cotización" },
  { icon: Zap, title: "Respuesta rápida" },
  { icon: ShieldAlert, title: "Daños físicos", note: "Robo, incendio, colisión" },
  { icon: Users, title: "Responsabilidad civil", note: "Daños a terceros", featured: true },
  { icon: Wrench, title: "Reparación en taller" },
  { icon: Building2, title: "Cobertura en faena y obra" },
  { icon: Truck, title: "Transporte del equipo", note: "Movilización" },
  { icon: Sparkles, title: "Deducibles inteligentes", note: "Adaptables a tu operación", featured: true },
  { icon: LifeBuoy, title: "Asistencia en terreno" },
  { icon: Cpu, title: "Cobertura de electrónica", note: "PC, celulares, equipos médicos" },
  { icon: Award, title: "Aseguradoras top de Chile" },
  { icon: HeadphonesIcon, title: "Ejecutivo asignado" },
];

export const Included = () => {
  return (
    <section id="incluye" className="border-y border-gray-100 bg-gray-50/70 py-12 sm:py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div>
          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-brand-yellow">
            <BadgeCheck className="h-4 w-4" /> Tu seguro incluye
          </p>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-brand-ink">
            Cobertura completa para tu maquinaria y equipos.
          </h2>
          <p className="mt-4 max-w-2xl text-base sm:text-lg text-gray-600">
            Daños físicos, responsabilidad civil y beneficios reales para operar
            tranquilo en el campo, la obra, la faena minera o la oficina.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.06 }}
              data-testid={`included-item-${i}`}
              className={`group relative flex items-center gap-3.5 rounded-2xl border bg-white p-4 transition-all hover:-translate-y-0.5 hover:shadow-lg hover:shadow-brand-ink/5 ${
                it.featured ? "border-brand-yellow/50 ring-1 ring-brand-yellow/20" : "border-gray-200 hover:border-brand-yellow/40"
              }`}
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition-transform group-hover:scale-105 ${
                  it.featured ? "bg-brand-yellow/20 text-brand-ink" : "bg-brand-ink/5 text-brand-ink"
                }`}
              >
                <it.icon className="h-5 w-5" />
              </span>
              <div className="min-w-0">
                <p className="font-display font-semibold leading-tight text-brand-ink">{it.title}</p>
                {it.note && (
                  <p className={`mt-0.5 text-xs font-medium ${it.featured ? "text-brand-ink/70" : "text-gray-500"}`}>
                    {it.note}
                  </p>
                )}
              </div>
              {it.featured && (
                <span className="absolute -top-2 right-4 rounded-full bg-brand-yellow px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-brand-ink shadow-sm">
                  Destacado
                </span>
              )}
            </motion.div>
          ))}
        </div>

        <p className="mt-6 text-xs text-gray-400">
          * Las coberturas y beneficios finales dependen de la póliza y aseguradora seleccionada en tu propuesta.
        </p>
      </div>
    </section>
  );
};
